// extracted by mini-css-extract-plugin
module.exports = {"large":"BigLogo-module--large--219l_","small":"BigLogo-module--small--PDO4A","logo":"BigLogo-module--logo--1WIgO"};